import React from 'react';
import Button from '@ingka/dual-button';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/focus/dist/style.css';
import '@ingka/dual-button/dist/style.css';

//This is the Skapa component "Dual Button"

export interface Props {
  prefix?: string;
  className?: string;
  disabledFirst?: boolean;
  disabledSecond?: boolean;
  small?: boolean;
  flipIconRTL?: boolean;
  orientation?: 'horizontal' | 'vertical';
  firstText?: string;
  secondText?: string;
  groupLabel?: string;
  onClickFirst?: (...args: any[]) => any;
  onClickSecond?: (...args: any[]) => any;
  ssrIconFirst?: (...args: any[]) => any;
  ssrIconSecond?: (...args: any[]) => any;
  type?: 'primary' | 'secondary';
  inverseTheme?: boolean;
}

const SkapaDualButton = ({
  prefix,
  className,
  disabledFirst,
  disabledSecond,
  small,
  flipIconRTL,
  orientation,
  firstText,
  secondText,
  groupLabel,
  onClickFirst,
  onClickSecond,
  ssrIconFirst,
  ssrIconSecond,
  type,
  inverseTheme
}: Props) => {
  return (
    <Button
      prefix={prefix}
      className={className}
      disabledFirst={disabledFirst}
      disabledSecond={disabledSecond}
      small={small}
      flipIconRTL={flipIconRTL}
      orientation={orientation}
      firstText={firstText}
      secondText={secondText}
      groupLabel={groupLabel}
      onClickFirst={onClickFirst}
      onClickSecond={onClickSecond}
      ssrIconFirst={ssrIconFirst}
      ssrIconSecond={ssrIconSecond}
      type={type}
      inverseTheme={inverseTheme}
    />
  );
};

export default SkapaDualButton;
